import { Component, Input } from '@angular/core';
import { magicPreviewDummyData } from '../../../classes/company';
import { GaugeDataInputType } from '../../html-snippet-components/gauge/gauge.component';

@Component({
  selector: 'aira-gauge',
  templateUrl: './aira-gauge.component.html',
  styleUrl: './aira-gauge.component.css',
  standalone: false,
})
export class AiraGaugeComponent {
  @Input() label = '';
  @Input() value: number;
  @Input() maximumValue: number;
  @Input() previewOnly: boolean = false;
  @Input() height: number | null = null;
  @Input() colours: string[] | null = null;

  // The child gauge rebuilds only when this object's identity changes, so it is
  // stored rather than built inline in the template.
  gaugeInput: GaugeDataInputType = { value: 0 };

  get displayValue(): number {
    return this.previewOnly ? magicPreviewDummyData.numberSimple : this.value;
  }

  // A genuine zero is an answer, not a missing one, so only null and undefined
  // count as "no insights".
  get hasValue(): boolean {
    return this.displayValue !== undefined && this.displayValue !== null;
  }

  ngOnInit() {
    this.rebuildGaugeInput();
  }

  ngOnChanges() {
    this.rebuildGaugeInput();
  }

  rebuildGaugeInput(): void {
    this.gaugeInput = {
      value: this.displayValue,
      maximumValue: this.maximumValue,
      height: this.height || undefined,
      colours: this.colours || undefined,
    };
  }
}
